import isEmpty from "lodash/isEmpty";
import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { NEED_MORE_INFO_ANSWER } from "./shared";
export var ChangeShippingAddressIA = function ChangeShippingAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  if (!brandOrder || !shippingContext) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return !isEmpty(shippingContext.shipments) ? ORDER_SHIPPED_ALREADY(strictLocalize) : ORDER_NOT_SHIPPED_YET(strictLocalize);
};
var ORDER_SHIPPED_ALREADY = function ORDER_SHIPPED_ALREADY(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return YOUR_ORDER_HAS_ALREADY_SHIPPED(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_ARE_NOT_USUALLY_ABLE_TO_CHANGE_SHIPPING_ADDRESS(strictLocalize), WITH_EXCEPTION_1(strictLocalize), WITH_EXCEPTION_2(strictLocalize), CONTACT_BRAND_FOR_OPTIONS(strictLocalize)];
    }
  };
};
var ORDER_NOT_SHIPPED_YET = function ORDER_NOT_SHIPPED_YET(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return CONTACT_BRAND_TO_CHANGE_ADDRESS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CONTACT_BRAND_DIRECTLY(strictLocalize)];
    }
  };
};
var YOUR_ORDER_HAS_ALREADY_SHIPPED = function YOUR_ORDER_HAS_ALREADY_SHIPPED(strictLocalize) {
  return strictLocalize({
    id: "11RITG",
    defaultMessage: [{
      "type": 0,
      "value": "A sua encomenda já foi enviada"
    }]
  });
};
var YOU_ARE_NOT_USUALLY_ABLE_TO_CHANGE_SHIPPING_ADDRESS = function YOU_ARE_NOT_USUALLY_ABLE_TO_CHANGE_SHIPPING_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "DDqFnG",
    defaultMessage: [{
      "type": 0,
      "value": "Na maioria dos casos, não pode alterar o endereço de envio depois de uma encomenda ter sido enviada. No entanto, existem algumas exceções:"
    }]
  });
};
var WITH_EXCEPTION_1 = function WITH_EXCEPTION_1(strictLocalize) {
  return strictLocalize({
    id: "csBiWk",
    defaultMessage: [{
      "type": 0,
      "value": "1) A marca acabou de criar a etiqueta e ainda não entregou a encomenda à transportadora."
    }]
  });
};
var WITH_EXCEPTION_2 = function WITH_EXCEPTION_2(strictLocalize) {
  return strictLocalize({
    id: "0VmuGe",
    defaultMessage: [{
      "type": 0,
      "value": "2) A marca pode contactar a transportadora e solicitar o reencaminhamento da encomenda (o que normalmente acarreta uma taxa)."
    }]
  });
};
var CONTACT_BRAND_FOR_OPTIONS = function CONTACT_BRAND_FOR_OPTIONS(strictLocalize) {
  return strictLocalize({
    id: "1s7sti",
    defaultMessage: [{
      "type": 0,
      "value": "Contacte a marca diretamente para ver as suas opções."
    }]
  });
};
var CONTACT_BRAND_TO_CHANGE_ADDRESS = function CONTACT_BRAND_TO_CHANGE_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "k+WnvC",
    defaultMessage: [{
      "type": 0,
      "value": "Contacte a marca para alterar o seu endereço de envio"
    }]
  });
};
var CONTACT_BRAND_DIRECTLY = function CONTACT_BRAND_DIRECTLY(strictLocalize) {
  return strictLocalize({
    id: "p8slbn",
    defaultMessage: [{
      "type": 0,
      "value": "Contacte a marca diretamente para solicitar a alteração do endereço de envio para esta encomenda. Receberá um e-mail a confirmar as alterações assim que a marca atualizar a encomenda com o novo endereço de envio."
    }]
  });
};